import { Box } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { CardsSkeletonVariant } from "./CardsSkeletonVariant";
import { ChartSkeletonVariant } from "./ChartSkeletonVariant";
import { DetailSkeletonVariant } from "./DetailSkeletonVariant";
import { FormSkeletonVariant } from "./FormSkeletonVariant";
import { GridSkeletonVariant } from "./GridSkeletonVariant";
import { ListSkeletonVariant } from "./ListSkeletonVariant";
import type { SkeletonVariant } from "./skeletonVariants";
import { TimelineSkeletonVariant } from "./TimelineSkeletonVariant";

const VARIANT_COMPONENTS: Record<SkeletonVariant, FC> = {
	grid: GridSkeletonVariant,
	timeline: TimelineSkeletonVariant,
	cards: CardsSkeletonVariant,
	chart: ChartSkeletonVariant,
	form: FormSkeletonVariant,
	detail: DetailSkeletonVariant,
	list: ListSkeletonVariant,
};

/**
 * A page's placeholder while its code loads (the route's Suspense fallback), in place of a spinner. The lazy route
 * names the page's category, and the placeholder draws that shape with random counts and widths, so the wait previews
 * the page that follows without matching it bar for bar.
 */
export const PageSkeleton: FC<{ variant: SkeletonVariant }> = ({ variant }) => {
	const { t } = useTranslation();
	const Variant = VARIANT_COMPONENTS[variant];

	return (
		<Box role="status" aria-busy="true" aria-label={t("Loading")} data-testid="page-skeleton" data-variant={variant} sx={{ width: "100%", p: 2 }}>
			<Variant />
		</Box>
	);
};
